<!-- src/components/forms/QuestionYesNo.vue -->

<template>
  <div>
    <label :for="id" class="form-label">{{ label }} <span class="text-red-500">*</span></label>
    <div class="mt-2 flex items-center space-x-4">
      <label :for="id + '-no'" class="flex items-center">
        <input :id="id + '-no'" :name="id" type="radio" :value="false" @change="updateModel(false)" :checked="modelValue === false" class="form-radio">
        <span class="ml-2">No</span>
      </label>
      <label :for="id + '-yes'" class="flex items-center">
        <input :id="id + '-yes'" :name="id" type="radio" :value="true" @change="updateModel(true)" :checked="modelValue === true" class="form-radio">
        <span class="ml-2">Yes</span>
      </label>
    </div>
    <div v-if="showDetails" class="mt-4">
      <label :for="id + '-details'" class="form-label text-sm text-gray-600">{{ detailsLabel }}</label>
      <textarea :id="id + '-details'" :value="details" @input="updateDetails" rows="3" class="form-input mt-1"></textarea>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  id: { type: String, required: true },
  label: { type: String, required: true },
  modelValue: { type: Boolean, default: null },
  details: { type: String, default: '' },
  detailsLabel: { type: String, default: 'If yes, please provide details' },
  isInvertedDetailsLogic: { type: Boolean, default: false }
});

const emit = defineEmits(['update:modelValue', 'update:details']);

const showDetails = computed(() => {
    if (props.isInvertedDetailsLogic) {
        return props.modelValue === false;
    }
    return props.modelValue === true;
});

const updateModel = (value) => {
  emit('update:modelValue', value);
};

const updateDetails = (event) => {
  emit('update:details', event.target.value);
};
</script>

<style scoped>
.form-label {
  @apply block text-sm font-medium text-gray-700;
}
.form-radio {
  @apply h-4 w-4 text-brand-primary border-gray-300 focus:ring-brand-accent;
}
.form-input {
  @apply block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-brand-primary focus:border-brand-primary sm:text-sm;
}
</style>